module.exports = __webpack_public_path__ + "static/mobile-device-shadow-2-7520c7740819178feb5a31e1c7a4c956.png";